import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {PaymentType} from '../../model/Entities/PaymentType';
import {ProductService} from '../../services/product.service';
import {Contract} from '../../model/Entities/Contract';
import {Customer} from '../../model/Entities/Customer';
import {Observable} from 'rxjs/Observable';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerService} from '../../services/customer.service';
import {MatTableDataSource} from '@angular/material';
import {ContractItem} from '../../model/Entities/ContractItem';
import {ContractService} from '../../services/contract.service';
import {FormControl, Validators} from '@angular/forms';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {numberValidator} from '../../validators/number.validator';
import {Product} from '../../model/Entities/Product';
import {ProductType} from '../../model/Entities/ProductType';
import {ContractState} from '../../model/Entities/ContractState';
import { HttpClient } from '@angular/common/http';
import {ContractItemService} from '../../services/contract-item.service';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemsListComponent} from '../ContractItemsListComponent/contract-items-list.component';
import {BarcodeService} from '../../services/barcode.service';

import * as moment from 'moment';
import {ContractItemType} from '../../model/Entities/ContractItemType';
import {intValidator} from '../../validators/int.validator';
import {positiveNumberValidator} from '../../validators/positiveNumber.validator';
import {ContractEventService} from '../../services/event.service';
import {ContractEvent} from '../../model/Entities/ContractEvent';
import {ContractMailDialogComponent} from '../ContractMailDialogComponent/contract-mail.dialog.component';
import {DialogService} from '../../services/dialog.service';
import {ContractEventDialogComponent} from '../ContractEventDialogComponent/contract-event.dialog.component';
import {DatetimeTermpickerComponent} from '../../SharedModule/DatetimeTermpickerComponent/datetime-termpicker.component';
import {ContractDeleteConfirmDialogComponent} from '../ContractDeleteConfirmDialogComponent/contract-delete-confirm.dialog.component';
import {Transport} from '../../model/Entities/Transport';
import {TransportDialogComponent} from '../TransportDialogComponent/transport.dialog.component';
import {TransportService} from '../../services/transport.service';
import {TransportDeleteConfirmDialogComponent} from '../TransportDeleteConfirmDialogComponent/transport-delete-confirm.dialog.component';
import {ContractConfirmMissingTransportDialogComponent} from '../ContractConfirmMissingTransportDialogComponent/contract-confirm-missing-transport.dialog.component';
import {environment} from '../../environments/environment';

@Component({
    selector: 'contract-edit',
    templateUrl: './contract-edit.component.html',
    styleUrls: ['./contract-edit.component.scss']
})
export class ContractEditComponent implements OnInit, AfterViewInit {
    readonly contractStateClass: any = ContractState;
    readonly contractItemTypeClass: any = ContractItemType;

    public contract: Contract = new Contract();
    public events: ContractEvent[] = [];
    // customer: Customer = new Customer();
    paymentType: any = PaymentType;

    editing = false;
    daysCountChanged = false;
    searchedCustomers: Customer[] = [];
    searchedProducts: Product[] = [];

    deliveryAddressIsSameAsInvoiceAddress = false;
    deliveryContactIsSameAsContactPerson = false;

    displayedColumns = ['itemName', 'itemCount', 'itemPrice', 'itemSale', 'itemVatRate', 'itemVat', 'itemTotal', 'actions'];
    itemsDataSource: MatTableDataSource<ContractItem> = new MatTableDataSource<ContractItem>([]);

    filters = {
        name: '',
        type: []
    };

    @ViewChild('customerSearch') customerSearch: ElementRef;

    @ViewChild('productSearch') productSearch: ElementRef;

    @ViewChild('itemsListComponent') itemsListComponent: ContractItemsListComponent;

    @ViewChild('fromDate') fromDate: DatetimeTermpickerComponent;
    @ViewChild('toDate') toDate: DatetimeTermpickerComponent;

    @ViewChild('search') search: ElementRef;

    // product: Product = new Product();


    nameFC = new FormControl('', [
        Validators.required,
    ]);

    invoiceStreetFC = new FormControl('', [
        // Validators.required,
    ]);

    invoiceCityFC = new FormControl('', [
        // Validators.required,
    ]);

    invoiceZipFC = new FormControl('', [
        // Validators.required,
    ]);

    companyNumberFC = new FormControl('', [
        Validators.required,
    ]);

    emailFC = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    phoneFC = new FormControl('', [
        Validators.required,
    ]);

    contactPersonFC = new FormControl('', [
        Validators.required,
    ]);

    refundableDepositFC = new FormControl('', [
        numberValidator(),
    ]);

    deliveryStreetFC = new FormControl('', [
        // Validators.required,
    ]);

    deliveryCityFC = new FormControl('', [
        // Validators.required,
    ]);

    deliveryZipFC = new FormControl('', [
        // Validators.required,
    ]);

    deliveryContactPersonFC = new FormControl('', [
        Validators.required,
    ]);

    backDeliveryStreetFC = new FormControl('', [
        // Validators.required,
    ]);

    backDeliveryCityFC = new FormControl('', [
        // Validators.required,
    ]);

    backDeliveryZipFC = new FormControl('', [
        // Validators.required,
    ]);

    backDeliveryContactPersonFC = new FormControl('', [
        Validators.required,
    ]);

    daysCountFC = new FormControl('', [
        Validators.required,
        positiveNumberValidator(false)
    ]);

    saleFC = new FormControl('', [
        Validators.required,
        numberValidator()
    ]);

    lossSaleFC = new FormControl(true, [Validators.required]);

    eventFC = new FormControl('', []);
    transports: Transport[];
    addresses: any[] = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private contractService: ContractService,
                private contractItemService: ContractItemService,
                private productService: ProductService,
                // private paymentTypeService: PaymentTypeService,
                private customerService: CustomerService,
                private contactPersonService: CustomerContactPersonService,
                private contractEventService: ContractEventService,
                public vatRateService: VatRateService,
                private snackService: SnackService,
                private http: HttpClient,
                public barcodeService: BarcodeService,
                private dialogService: DialogService,
                private transportService: TransportService,
                private cdr: ChangeDetectorRef) {

        this.contract.fromStart.setHours(8, 0, 0, 0);
        this.contract.fromEnd.setHours(18, 0, 0, 0);
        this.contract.toStart.setHours(8, 0, 0, 0);
        this.contract.toEnd.setHours(18, 0, 0, 0);
    }

    ngOnInit(): void {
        const id = +this.route.snapshot.paramMap.get('id');
        if (id !== 0) {
            this.editing = true;
            this.loadContract(id);
        }

        this.loadEvents();
    }

    ngAfterViewInit(): void {
        // INIT CUSTOMERS AUTOCOMPLETE
        Observable.fromEvent(this.customerSearch.nativeElement, 'keyup')
            .debounceTime(300)
            .distinctUntilChanged().subscribe((e) => {

            const searchValue = this.customerSearch.nativeElement.value.trim();

            this.customerService.getSimpleList([
                new Filter('search', searchValue)
            ]).subscribe((data: Customer[]) => {
                this.searchedCustomers = data;
                // console.log(this.searchedCustomers);
            });
        });

        // INIT PRODUCTS AUTOCOMPLETE
        Observable.fromEvent(this.productSearch.nativeElement, 'keyup')
            .debounceTime(300)
            .distinctUntilChanged().subscribe((e) => {

            this.productService.getSimpleList([
                new Filter('name', '*' + this.productSearch.nativeElement.value.trim() + '*')
            ], {expand: 'content'}).subscribe((data: Product[]) => {
                this.searchedProducts = data;
            });
        });

        // INTI CONTRACT ITEMS SEARCH
        Observable.fromEvent(this.search.nativeElement, 'keyup').debounceTime(150).distinctUntilChanged().subscribe((e) => {
            this.filters.name = this.search.nativeElement.value.trim();
            this.updateListFilters();
        });
    }

    updateListFilters(): void {
        this.itemsListComponent.setFilters(this.filters);
    }

    resetFilters(): void {
        this.filters = {
            name: '',
            type: []
        };

        this.updateListFilters();
    }

    public changeStateContract(): void {
        // console.log('confirmManualContract');

        this.contractService.update(this.contract.id, this.contract).subscribe(() => {
            this.snackService.showSuccess(`Stav zápůjčky č. ${this.contract.id} byla nastaven`);
        });

    }

    termChange(): void {
        if (!this.daysCountChanged) {
            let previous = this.contract.daysCount;
            this.contract.daysCount = this.getDaysCountFromTerm();

            this.contract.items.forEach((ci: ContractItem) => {
                if (!ci.daysChanged) {
                    ci.days = this.contract.daysCount;
                }
            });
        }
    }

    fromDateChange(): void {
        this.contract.toStart = new Date(this.contract.fromStart.getTime());
        this.contract.toEnd = new Date(this.contract.fromEnd.getTime());
        this.termChange();
    }

    daysCountChange(): void {
        console.log("DAYS COUNT");
        console.log("Set:" , this.contract.daysCount);
        console.log("Calculated: ", this.getDaysCountFromTerm());
        this.daysCountChanged = +this.contract.daysCount !== this.getDaysCountFromTerm();
    }

    getDaysCountFromTerm(): number {
        const millis = moment(this.contract.toEnd).startOf('day').unix() - moment(this.contract.fromStart).startOf('day').unix();
        const days = Math.floor(millis / 60 / 60 / 24);
        return Math.max(1, days);
    }

    customerSelected(c: Customer): void {
        this.contract.customer = c;
        this.contract.paymentType = this.contract.customer.paymentType;
        this.contract.customerId = this.contract.customer.id;
        this.contract.contactId = null;
        this.contract.lossSale = c.lossSale;

        [this.nameFC, this.invoiceStreetFC, this.invoiceCityFC,
            this.invoiceZipFC, this.companyNumberFC, this.contactPersonFC]
            .forEach((fc: FormControl) => fc.markAsTouched());

        this.contactPersonService.getSimpleList([new Filter('customer_id', c.id)])
            .subscribe((persons: CustomerContactPerson[]) => {
                this.contract.customer.contacts = persons;
            });
    }

    copyAddress(type): void {
        if (!this.contract.customer.addressLat) {
            this.snackService.showWarn('Převzít adresu se nepodařilo. Prosím znovuzadejte adresu u zákazníka.');
        } else {
            switch (type) {
                case 'back':
                    this.contract.backDeliveryBuilding = this.contract.deliveryBuilding;
                    this.contract.backDeliveryStreet = this.contract.customer.invoiceStreet;
                    this.contract.backDeliveryCity = this.contract.customer.invoiceCity;
                    this.contract.backDeliveryZip = this.contract.customer.invoiceZip;
                    this.contract.backDeliveryAddress = this.contract.customer.address;
                    this.contract.backDeliveryAddressLon = this.contract.customer.addressLon;
                    this.contract.backDeliveryAddressLat = this.contract.customer.addressLat;
                    break;
                default:
                    this.contract.deliveryStreet = this.contract.customer.invoiceStreet;
                    this.contract.deliveryCity = this.contract.customer.invoiceCity;
                    this.contract.deliveryZip = this.contract.customer.invoiceZip;
                    this.contract.deliveryAddress = this.contract.customer.address;
                    this.contract.deliveryAddressLon = this.contract.customer.addressLon;
                    this.contract.deliveryAddressLat = this.contract.customer.addressLat;
            }
        }
    }

    getCurrentContactPerson(): CustomerContactPerson {
        let person = this.contract.customer.contacts.find((p: CustomerContactPerson) => {
            return p.id === this.contract.contactId;
        });
        return Object.assign(new CustomerContactPerson(), person);
    }

    copyContact(type: any): void {
        const contact: CustomerContactPerson = this.getCurrentContactPerson();

        if (!contact) {
            return;
        }

        switch (type) {
            case 'back':
                this.contract.backDeliveryContactPerson = contact.getFullName();
                this.contract.backDeliveryPhone = contact.phone;
                this.contract.backDeliveryEmail = contact.email;
                break;
            default:
                this.contract.deliveryContactPerson = contact.getFullName();
                this.contract.deliveryPhone = contact.phone;
                this.contract.deliveryEmail = contact.email;
        }
    }

    save(): void {
        if (this.editing) {
            this.performSaveOrShowTransportDialog(() => this.performUpdateContract());
        } else if (!this.contract.customerId) {
            this.contract.customer.invoiceName = this.contract.customer.name;

            const newContact: CustomerContactPerson = new CustomerContactPerson();
            newContact.surname = this.contract.customer.name;
            newContact.email = this.contract.customer.email;
            newContact.phone = this.contract.customer.phone;

            this.customerService.save(this.contract.customer).subscribe((c: Customer) => {
                this.contract.customer = this.contract.customer = c;
                this.contract.customerId = c.id;

                newContact.customerId = this.contract.customer.id;

                this.contactPersonService.save(newContact).subscribe((cp: CustomerContactPerson) => {

                    if (!this.contract.customer.contacts) {
                        this.contract.customer.contacts = [];
                    }

                    if (this.deliveryContactIsSameAsContactPerson) {
                        this.contract.deliveryContactPerson = cp.getFullName();
                        this.contract.deliveryEmail = cp.email;
                        this.contract.deliveryPhone = cp.phone;
                    }

                    this.contract.customer.contacts.push(cp);
                    // console.log('CUST2', this.contract.customer);
                    this.contract.contactId = cp.id;
                    this.saveContract();
                });
            });
        } else {
            this.saveContract();
        }
    }

    termValid(): boolean {
        return this.contract.fromStart <= this.contract.fromEnd
            && this.contract.toStart <= this.contract.toEnd
            && this.contract.fromEnd < this.contract.toStart;
    }

    isContractLongerThanWeek(): boolean {
        const from = new Date(this.contract.fromStart);
        const to = new Date(this.contract.toStart);
        const diffMs = to.getTime() - from.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        return diffDays > 7;
    }

    checkAvailability(): boolean {
        for (let i = 0; i < this.contract.items.length; i++) {
            if (this.contract.items[i].isAvailable() === false) {
                return false;
            }
        }
        return true;
    }

    checkValidityAdmin(): boolean {
        // return true;

        return this.termValid()     // Terms validation
            // && this.checkAvailability()     // Products availability validation
            && ((this.isCustomerSelected() && !!this.contract.contactId)      // Customer selected or filled
                || (this.nameFC.valid
                    && this.invoiceStreetFC.valid
                    && this.invoiceCityFC.valid
                    && this.invoiceZipFC.valid
                    && (!this.contract.customer.enterprise || this.companyNumberFC.valid)
                    && this.phoneFC.valid
                    && this.emailFC.valid))
            && (!this.contract.delivery || (        // Delivery address validation
                (this.deliveryAddressIsSameAsInvoiceAddress
                    || (this.deliveryStreetFC.valid
                        && this.deliveryCityFC.valid
                        && this.deliveryZipFC.valid))
                && (this.deliveryContactIsSameAsContactPerson
                    || this.deliveryContactPersonFC.valid)
            ))
            && this.refundableDepositFC.valid
            && this.daysCountFC.valid
            && this.saleFC.valid;
    }

    checkValidityDriver(): boolean {
        return true;
    }

    isCustomerSelected(): boolean {
        return !!this.contract.customerId;
    }

    addTextItem(): void {
        this.itemsListComponent.addCustomItem('Text', ContractItemType.text);
    }

    addItem(p: Product | null):void {
        if (p === null) {
            // console.log('ADD', p);
            this.itemsListComponent.addCustomItem('Nová položka');
            return;
        }

        this.productSearch.nativeElement.value = '';
        this.searchedProducts = [];


        // if (p.type === ProductType.group) {
        //     p.content.forEach(pc => {
        //         this.itemsListComponent.addItem(pc.content, pc.count);
        //     });
        // } else {
        this.itemsListComponent.addItem(p);
        // }

    }

    clearDelivery(direction: string) {
        if (direction === 'in') {
            this.contract.deliveryInternalNote = null;
            this.contract.deliveryAddress = null;
            this.contract.deliveryAddressLat = null;
            this.contract.deliveryAddressLon = null;
            this.contract.deliveryEmail = null;
            this.contract.deliveryPhone = null;
            this.contract.deliveryBuilding = null;
            this.contract.deliveryContactPerson = null;
            this.contract.deliveryCity = null;
            this.contract.deliveryStreet = null;
            this.contract.deliveryZip = null;
        } else {
            this.contract.backDeliveryInternalNote = null;
            this.contract.backDeliveryAddress = null;
            this.contract.backDeliveryAddressLat = null;
            this.contract.backDeliveryAddressLon = null;
            this.contract.backDeliveryEmail = null;
            this.contract.backDeliveryPhone = null;
            this.contract.backDeliveryBuilding = null;
            this.contract.backDeliveryContactPerson = null;
            this.contract.backDeliveryCity = null;
            this.contract.backDeliveryStreet = null;
            this.contract.backDeliveryZip = null;
        }
    }

    toggleAdditional(type: ContractItemType, name: string, value: boolean): void {
        if (!this.editing) {
            console.log('Contract not saved. Skipping ' + name);
            return;
        }

        if (!value) {

            if (type === ContractItemType.delivery && (this.contract.delivery || this.contract.backDelivery)) {
                return;
            }

            this.itemsListComponent.removeItemsByType(type);

            // remove the deployment also
            if (type === ContractItemType.delivery) {
                this.itemsListComponent.removeItemsByType(ContractItemType.deployment);
            }
        } else {
            for (const item of this.contract.items) {
                if (item.type === type) {
                    // Do not add the same additional type
                    return;
                }
            }

            this.itemsListComponent.addCustomItem(name, type);
        }
    }

    openAddContractEventDialog(eventId: number = null): void {
        this.dialogService.showDialog(ContractEventDialogComponent, {
            contract: this.contract,
            eventId: eventId
        }, 800).afterClosed().subscribe((result) => {
            if (result && eventId) {
                this.contractEventService.update(eventId, result).subscribe((e: ContractEvent) => {
                    this.snackService.showSuccess(`Akce ${e.name} byla upravena`);
                    this.loadEvents(e.id);
                });
            } else if (result) {
                this.contractEventService.save(result).subscribe((e: ContractEvent) => {
                    this.snackService.showSuccess(`Akce ${e.name} byla vytvořena`);
                    this.loadEvents(e.id);
                });
            }
        });
    }

    sortItems(): void {
        this.contractItemService.sortData(this.contract.id).subscribe(() => {
            this.itemsListComponent.loadContractItems(this.contract.id);
            this.snackService.showSuccess('Položky byly seřazeny');
        });
    }

    // transport

    addTransport(type = null): void {
        let transport = new Transport();
        transport.transportFrom = this.contract.fromStart;
        transport.transportTo = this.contract.fromEnd;

        if (type === 'in') {
            transport.type = 'in';
            if (this.contract.deliveryAddress) {
                transport.address = this.contract.deliveryAddress;
                transport.addressLon = this.contract.deliveryAddressLon;
                transport.addressLat = this.contract.deliveryAddressLat;
            }
        }

        if (type === 'out') {
            transport.type = 'out';
            transport.transportFrom = this.contract.toStart;
            transport.transportTo = this.contract.toEnd;
            if (this.contract.backDeliveryAddress) {
                transport.address = this.contract.backDeliveryAddress;
                transport.addressLon = this.contract.backDeliveryAddressLon;
                transport.addressLat = this.contract.backDeliveryAddressLat;
            }
        }

        this.openTransportDialog(transport);
    }

    editTransport(transport) {
        this.openTransportDialog(transport);
    }

    private openTransportDialog(transport: Transport): void {
        this.dialogService.showDialog(TransportDialogComponent, {
            'transport': transport,
            'contract': this.contract
        }, 1000, 800).afterClosed().subscribe((result) => {
                if (!result) {
                    this.loadTransport();
                    return;
                }
                if (!result.id) {
                    // create
                    this.transportService.save(transport).subscribe((t: Transport) => {
                        this.snackService.showSuccess(`Doprava byla přidána`);
                        this.loadTransport();
                    });
                } else {
                    // update
                    this.transportService.update(result.id, transport).subscribe((t: Transport) => {
                        this.snackService.showSuccess(`Doprava byla upravena`);
                        this.loadTransport();
                    });
                }
            }
        );
    };

    deleteTransport(transport) {
        this.dialogService.showDialog(TransportDeleteConfirmDialogComponent, {
            'transport': transport,
        }).afterClosed().subscribe((result) => {
                if (result) {
                    this.transportService.delete(transport.id).subscribe(() => {
                        this.snackService.showSuccess(`Doprava byla smazána`);
                        this.loadTransport();
                    });
                }
            }
        );
    }

    selectAddress(address) {
        this.contract.deliveryCity = '';
        this.contract.deliveryZip = '';
        this.contract.deliveryStreet = '';
        this.contract.deliveryBuilding = '';
        let hasMunicipalityPart = address.regionalStructure.some(s => s.type === 'regional.municipality_part');
        address.regionalStructure.forEach(structure => {
            if (structure.name != undefined) {
                if (structure.type === 'regional.municipality_part') {
                    if (this.contract.deliveryCity !== '') {
                        this.contract.deliveryCity = structure.name + ' - ' + this.contract.deliveryCity;
                    } else {
                        this.contract.deliveryCity = structure.name;
                    }
                }
                if (structure.type === 'regional.municipality' && !hasMunicipalityPart) {
                    this.contract.deliveryCity = structure.name;
                }
                if (structure.type === 'regional.street' || structure.type === 'regional.address') {
                    this.contract.deliveryStreet = structure.name + ' ' + this.contract.deliveryStreet;
                }
                if (address.type === "poi") {
                    this.contract.deliveryBuilding = address.name;
                }
            }
        });
        this.contract.deliveryZip = address.zip;
        this.contract.deliveryAddress = address.name + ', ' + address.zip + ', ' + address.location;
        this.contract.deliveryAddressLat = address.position.lat;
        this.contract.deliveryAddressLon = address.position.lon;
    }
    selectContractAddress(address) {
        this.contract.customer.invoiceCity = '';
        this.contract.customer.invoiceZip = '';
        this.contract.customer.invoiceStreet = '';
        let hasMunicipalityPart = address.regionalStructure.some(s => s.type === 'regional.municipality_part');
        address.regionalStructure.forEach(structure => {
            if (structure.name != undefined) {
                if (structure.type === 'regional.municipality_part') {
                    if (this.contract.customer.invoiceCity !== '') {
                        this.contract.customer.invoiceCity = structure.name + ' - ' + this.contract.customer.invoiceCity;
                    } else {
                        this.contract.customer.invoiceCity = structure.name;
                    }
                }
                if (structure.type === 'regional.municipality' && !hasMunicipalityPart) {
                    this.contract.customer.invoiceCity = structure.name;
                }
                if (structure.type === 'regional.street' || structure.type === 'regional.address') {
                    this.contract.customer.invoiceStreet = structure.name + ' ' + this.contract.customer.invoiceStreet;
                }
            }
        });
        this.contract.customer.invoiceZip = address.zip;
        this.contract.customer.address = address.name + ', ' + address.zip + ', ' + address.location;
        this.contract.customer.addressLat = address.position.lat;
        this.contract.customer.addressLon = address.position.lon;
    }

    selectBackAddress(address) {
        this.contract.backDeliveryCity = '';
        this.contract.backDeliveryZip = '';
        this.contract.backDeliveryStreet = '';
        this.contract.backDeliveryBuilding = '';
        let hasMunicipalityPart = address.regionalStructure.some(s => s.type === 'regional.municipality_part');
        address.regionalStructure.forEach(structure => {
            if (structure.type === 'regional.municipality_part') {
                if (this.contract.backDeliveryCity !== '') {
                    this.contract.backDeliveryCity = structure.name + ' - ' + this.contract.backDeliveryCity;
                } else {
                    this.contract.backDeliveryCity = structure.name;
                }
            }
            if (structure.type === 'regional.municipality' && !hasMunicipalityPart) {
                this.contract.backDeliveryCity = structure.name;
            }
            if (structure.type === 'regional.street' || structure.type === 'regional.address') {
                this.contract.backDeliveryStreet = structure.name + ' ' + this.contract.backDeliveryStreet;
            }
            if (address.type === "poi") {
                this.contract.backDeliveryBuilding = address.name;
            }
        });
        this.contract.backDeliveryZip = address.zip;
        this.contract.backDeliveryAddress = address.name + ', ' + address.zip + ', ' + address.location;
        this.contract.backDeliveryAddressLat = address.position.lat;
        this.contract.backDeliveryAddressLon = address.position.lon;
    }

    searchAddress($event: KeyboardEvent) {
        const search = $event.target['value'];
        this.loadAddresses(search);
    }

    loadAddresses(search: string) {
        if (!search || search.length < 3) {
            this.addresses = [];
            return;
        }

        const apiKey = environment.apiMapyCom;
        const url = `https://api.mapy.com/v1/suggest?query=${encodeURIComponent(search)}&type=regional.address,poi&apiKey=${apiKey}`;

        this.http.get<any>(url).subscribe(
            (response) => {
                this.addresses = response.items || [];
            },
            (error) => {
                console.error("Nepodařilo se načíst adresy:", error);
                this.addresses = [];
            }
        );
    }

    private saveContract(): void {
        if (this.deliveryAddressIsSameAsInvoiceAddress) {
            this.contract.deliveryStreet = this.contract.customer.invoiceStreet;
            this.contract.deliveryCity = this.contract.customer.invoiceCity;
            this.contract.deliveryZip = this.contract.customer.invoiceZip;
        }

        if (this.deliveryContactIsSameAsContactPerson) {
            const cp = this.getCurrentContactPerson();
            this.contract.deliveryContactPerson = cp.getFullName();
            this.contract.deliveryEmail = cp.email;
            this.contract.deliveryPhone = cp.phone;
        }

        this.contractService.save(this.contract).subscribe((c: Contract) => {
            this.snackService.showSuccess(`Zápůjčka č. ${c.id} byla vytvořena`);
            // console.log('VYTVO5ENA');

            const initialItems = [];

            if (c.delivery || c.backDelivery) {
                initialItems.push({
                    type: ContractItemType.delivery,
                    name: 'Doprava'
                });
            }

            if (c.deployment) {
                initialItems.push({
                    type: ContractItemType.deployment,
                    name: 'Montáž'
                });
            }

            this.router.navigate([`/contract/${c.id}/edit`]).then(() => {
                this.loadContract(c.id, initialItems);
                this.editing = true;
            });
        });
    }

    private loadContract(id: Number, initialItems: { name, type }[] = []): void {
        this.contractService.get(id).subscribe((c: Contract) => {

            this.contract = c;
            this.contract.customer = new Customer();
            this.contract.items = [];

            // wait until the itemsListComponent is initialized
            setTimeout(() => {
                if (initialItems.length > 0) {
                    initialItems.forEach(item => {
                        this.itemsListComponent.addCustomItem(item.name, item.type);
                    });
                }
            }, 500);

            this.loadCustomer(c.customerId);
            this.loadTransport();
            this.daysCountChange();
        });
    }

    private loadTransport(): void {
        this.transportService.getSimpleList([new Filter('contract_id', this.contract.id)], { expand: 'users' }).subscribe((transports: Transport[]) => {
            this.transports = transports;
        })
    }

    private performSaveOrShowTransportDialog(onConfirm: () => void): void {
        const isConfirmingState = this.contract.state === ContractState.confirmed;
        const missingDelivery = isConfirmingState && this.contract.delivery && (!this.transports || !this.transports.some(t => t.type === 'in'));
        const missingBackDelivery = isConfirmingState && this.contract.backDelivery && (!this.transports || !this.transports.some(t => t.type === 'out'));

        if (missingDelivery || missingBackDelivery) {
            this.dialogService.showDialog(ContractConfirmMissingTransportDialogComponent, {
                missingDelivery,
                missingBackDelivery
            }).afterClosed().subscribe((result: boolean) => {
                if (result) {
                    onConfirm();
                }
            });
        } else {
            onConfirm();
        }
    }

    private performUpdateContract(): void {
        this.contractService.update(this.contract.id, this.contract).subscribe(() => {
            this.router.navigate([`/contract/${this.contract.id}`]);
            this.snackService.showSuccess(`Zápůjčka č. ${this.contract.id} byla upravena`);
        });
    }

    private loadCustomer(id: Number): void {
        this.customerService.get(id, {expand: 'contacts'}).subscribe((customer: Customer) => {
            // console.log('LOADED CUSTOMER', customer);
            this.contract.customer = customer;
            // this.contract.customer.contacts = this.contract.customer.contacts as CustomerContactPerson[];
        });
    }

    private loadEvents(defaultEventId: number = null): void {
        this.contractEventService.getSimpleList().subscribe((events: ContractEvent[]) => {
            this.events = events;
            if (defaultEventId !== null) {
                this.contract.eventId = defaultEventId;
            }
        });
    }

    openCustomer(customer: Customer) {
        window.open(`/customer/${customer.id}`, '_blank');
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractEditComponent/contract-edit.component.ts